import { createBrowserRouter, Navigate } from "react-router-dom";
import DefaultLayout from "../components/layouts/DefaultLayout";
import { PrivateRoutes, PublicRoutes } from "./Routes";
import ErrorBoundary from "../components/ErrorBoundary";
import AuthenticatedLayout from "../components/layouts/AuthenticatedLayout";

const router = createBrowserRouter([
  {
    element: <DefaultLayout />,
    children: [
      ...PublicRoutes.map((route) => ({
        path: route.path,
        element: <route.view />,
        errorElement: <ErrorBoundary />,
      })),
      { path: "*", element: <Navigate to="/login" /> },
    ],
  },
  {
    element: <AuthenticatedLayout />,
    children: [
      ...PrivateRoutes.map((route) => ({
        path: route.path,
        element: <route.view />,
        errorElement: <ErrorBoundary />,
      })),
      { path: "*", element: <Navigate to="/employments" /> },
    ],
  },
]);

export default router;
